import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=2db13395&scoped=true&lang=pug"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"
import style0 from "./Listado.vue?vue&type=style&index=0&id=2db13395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db13395",
  null
  
)

export default component.exports